export default __webpack_public_path__ + "static/media/foci-call-logging.57794616.svg";